export const getConfigureDatasources = (state) => ({
  initialRows: state.configureDatasources.initialRows,
  rows: state.configureDatasources.rows,
  deleteRowId: state.configureDatasources.deleteRowId,
  source: state.configureDatasources.source,
  status: {
    isLoading: state.configureDatasources.status.isLoading,
    hasChanges: state.configureDatasources.status.hasChanges,
    hasEmptyFields: state.configureDatasources.status.hasEmptyFields,
    isImportModalOpen: state.configureDatasources.status.isImportModalOpen,
    isDeleteModalOpen: state.configureDatasources.status.isDeleteModalOpen,
    isExternalDataModalOpen: state.configureDatasources.status.isExternalDataModalOpen,
  },
});

export const getConfigureExternalDatasources = (state) => ({
  query: state.configureDatasources.query,
  sourceDataList: state.configureDatasources.sourceDataList,
  status: {
    isQueryResultLoading: state.configureDatasources.status.isQueryResultLoading,
    isExporting: state.configureDatasources.status.isExporting,
    enableQueryAction: state.configureDatasources.status.enableQueryAction,
  },
});
